import { apiOrigin } from '../utils/surface';

export const STRIPE_PUBLISHABLE_KEY = 'pk_test_51T2dzsQ40Cmvw4cRgXSoIFHE55CzHtDjZqmbZazICbRUsEf5E3L4Jc3dACBFxktCZkggVTPG7AvgatmDVuf4SK7O00M5RiF2ie';
export const STRIPE_PROXY_URL = `${apiOrigin()}/stripe`;

// Product IDs (test account)
export const PRODUCTS = {
  PROPERTY_BASE: 'prod_U0fNZvC5Eh28lb',
  DEVICE: 'prod_U29QZQeRbevKGf',        // Active metered product
  UNIT: 'prod_U29QRsjloWbcwY',          // Active metered product
};

// Price IDs (quantity-based recurring prices)
// NOTE: Update these prices in Stripe Dashboard to:
//   - PER_UNIT: $1.50/unit/month
//   - PER_DEVICE: $5.00/device/month
export const PRICES = {
  PROPERTY_BASE: 'price_1T4LUtQ40Cmvw4cRt9ZxSuEc',
  PER_DEVICE: 'price_1T4LUuQ40Cmvw4cRCP7EUEso',    // Set to $5.00/device/month
  PER_UNIT: 'price_1T4LUtQ40Cmvw4cRtruZSILb',      // Set to $1.50/unit/month
};

// Billing Meters (usage-based)
export const METERS = {
  DEVICE_ACTIVE: 'mtr_test_61UC2VTHAjcwYy3ZH41Q40Cmvw4cR0Xg',
  UNIT_ACTIVE: 'mtr_test_61UC2VTukHQv4m6NW41Q40Cmvw4cRNto',
  TALK_MINUTES: 'mtr_test_61UC2VUmT4HcqZoLG41Q40Cmvw4cRGVc',
  VIDEO_MINUTES: 'mtr_test_61UC2YeOAsbrvJhAi41Q40Cmvw4cRGxU',
};

// Metered price IDs (usage-based billing)
// Active products with correct pricing:
//   - PER_UNIT: $1.50/unit (prod_U29QRsjloWbcwY)
//   - PER_DEVICE: $5.00/device (prod_U29QZQeRbevKGf)
export const METERED_PRICES = {
  PER_DEVICE: 'price_1T457rQ40Cmvw4cRFU1gip80',      // $5.00/device
  PER_UNIT: 'price_1T457LQ40Cmvw4cREj7jF230',        // $1.50/unit
  PER_TALK_MINUTE: 'price_1T2eYLQ40Cmvw4cRjIdXeDko',
  PER_VIDEO_MINUTE: 'price_1T2ebJQ40Cmvw4cRBgKjxJwI',
};

// Talk Minutes product
export const TALK_MINUTES_PRODUCT = 'prod_U0fu7i2t6FiicT';

export const VIDEO_MINUTES_PRODUCT = 'prod_U0fx33G6tzc4Ru';

// Device pricing tiers
export const DEVICE_RATE_STANDARD = 5;   // $5/device/month
// DEVICE_RATE_PREMIUM removed — Seam integration (smart locks) disabled

// All devices now use standard pricing
const PREMIUM_PROVIDERS = new Set<string>();

export function isPremiumDevice(device: any): boolean {
  return false; // No premium devices with Seam disabled
}

export function calcDeviceCost(devices: any[]): number {
  let total = 0;
  for (const d of devices) {
    // All devices use standard pricing — premium devices (Seam) disabled
    total += DEVICE_RATE_STANDARD;
  }
  return total;
}

export function countPremiumDevices(devices: any[]): number {
  return devices.filter(isPremiumDevice).length;
}

export function countStandardDevices(devices: any[]): number {
  return devices.filter(d => !isPremiumDevice(d)).length;
}
